module.exports = __webpack_public_path__ + "img/detailLogo.98f65da3.png";